(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nq-crosssell"] && !Shopify.designMode) return;
  try {
    (function () {
    function initXsell(slider) {
      var track = slider.querySelector('[data-xs-track]');
      var prev = slider.querySelector('[data-xs-prev]');
      var next = slider.querySelector('[data-xs-next]');
      if (!track) return;
      function step() {
        var c = track.querySelector('.nqc-card');
        return c ? (c.offsetWidth + 30) : 320;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.toggleAttribute('disabled', track.scrollLeft <= 2);
        if (next) next.toggleAttribute('disabled', track.scrollLeft >= max);
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
    function initAll() {
      document.querySelectorAll('[data-xs-slider]').forEach(function (s) {
        if (s.dataset.xsBound) return;
        s.dataset.xsBound = '1';
        initXsell(s);
      });
    }
    initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
